








































import { Component, Vue } from 'vue-property-decorator';

@Component({
    name: 'UseCard',
})
export default class UseCard extends Vue {}
